module.exports = __webpack_public_path__ + "img/family-pants.a5db92bc.svg";